/* Program Name: ProxyContext.js
 **  Description: a component that handles the state of proxy related actions
 **
 ** Project    Date        Who  Comments
 ** --------  ----------  ---  ---------------------------------------------------
 ** SD6391    2025-01-21  SGS  Initial program.
 *********************************************************************************/

/**React imports */
import React, { createContext, useState, useContext } from 'react'

//Creates the ProxtContext using reacts context //DOCS: https://reactjs.org/docs/context.html
const ProxyContext = createContext()

//Creates the hook to access the state of the LoadingContext //DOCS: https://reactjs.org/docs/hooks-custom.html
export function useProxy() {
  return useContext(ProxyContext)
}

export default function ProxyProvider({ children }) {
  /*********************************************************************************************** */
  /**Local Variables */
  const [detectChange, setDetectChange] = useState(false)

  /*********************************************************************************************** */
  /**Local Functions */

  /**State Reload*/
  /******************************************************************************/
  /** Toggles the `detectChange` state to notify dependent components to retreive updated state
   ** when a proxy is initialized or disconnected
   */
  const stateReload = () => {
    setDetectChange((prevState) => !prevState)
  }

  //value is the object that is passed into the Provider which allows anything in the value to be access
  //by the children of AlertProvider
  const value = {
    detectChange,
    setDetectChange,
    stateReload,
  }

  /*********************************************************************************************** */
  /**Rendering */
  return <ProxyContext.Provider value={value}>{children}</ProxyContext.Provider>
}
